/* THE BIN ID CO. — Hero Carousel */
(function(){
  var track = document.getElementById('csTrack');
  if(!track) return;

  var slides = Array.from(track.querySelectorAll('.cs-slide'));
  var dots   = Array.from(document.querySelectorAll('.cs-dot'));
  var numEl  = document.getElementById('csNum');
  var bar    = document.getElementById('csBar');
  var total  = slides.length;
  var cur    = 0;
  var tmr    = null;
  var barTmr = null;
  var INTERVAL = 4000;

  function goTo(n){
    if(n === cur) return;
    // exit current
    slides[cur].classList.remove('cs-active');
    slides[cur].classList.add('cs-out-l');
    var old = cur;
    setTimeout(function(){ slides[old].classList.remove('cs-out-l'); }, 450);
    // enter new
    cur = ((n % total) + total) % total;
    slides[cur].classList.add('cs-active');
    // dots
    dots.forEach(function(d,i){ d.classList.toggle('cs-dot-on', i===cur); });
    if(numEl) numEl.textContent = cur + 1;
  }

  function next(){ goTo(cur+1); }
  function prev(){ goTo(cur-1); }

  function startBar(){
    if(!bar) return;
    clearTimeout(barTmr);
    bar.style.transition = 'none';
    bar.style.width = '0%';
    // force reflow
    bar.offsetWidth;
    bar.style.transition = 'width '+INTERVAL+'ms linear';
    bar.style.width = '100%';
  }

  function startAuto(){
    clearInterval(tmr);
    tmr = setInterval(function(){ next(); startBar(); }, INTERVAL);
    startBar();
  }

  function stopAuto(){
    clearInterval(tmr);
    clearTimeout(barTmr);
    if(bar){ bar.style.transition='none'; bar.style.width='0%'; }
  }

  // Wiring
  var btnNext = document.getElementById('csNext');
  var btnPrev = document.getElementById('csPrev');
  if(btnNext) btnNext.addEventListener('click', function(){ stopAuto(); next(); startAuto(); });
  if(btnPrev) btnPrev.addEventListener('click', function(){ stopAuto(); prev(); startAuto(); });

  dots.forEach(function(dot){
    dot.addEventListener('click', function(){
      stopAuto();
      goTo(parseInt(dot.dataset.slide));
      startAuto();
    });
  });

  // Touch swipe
  var tx = 0;
  track.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; },{passive:true});
  track.addEventListener('touchend', function(e){
    var dx = e.changedTouches[0].clientX - tx;
    if(Math.abs(dx) > 44){ stopAuto(); (dx < 0 ? next : prev)(); startAuto(); }
  },{passive:true});

  // Keyboard
  document.addEventListener('keydown', function(e){
    if(e.key==='ArrowRight'){ stopAuto(); next(); startAuto(); }
    if(e.key==='ArrowLeft'){  stopAuto(); prev(); startAuto(); }
  });

  // Pause on hover
  track.addEventListener('mouseenter', stopAuto);
  track.addEventListener('mouseleave', startAuto);

  // Pause when tab not visible
  document.addEventListener('visibilitychange', function(){
    document.hidden ? stopAuto() : startAuto();
  });

  startAuto();
})();
